import { css } from 'lit';

export default css`
  :host {
    display: block;
    --tagger-border: 1px solid var(--border-subtle);
    --tagger-border-radius: var(--radius-lg);
    --tagger-padding: var(--spacing-sm);
    --tagger-min-width: stretch;
    --input-padding: var(--spacing-sm);
    --input-border: none;
    --suggestion-bg: var(--surface-raised);
    --suggestion-border: 1px solid var(--border-subtle);
    --suggestion-max-height: 180px;
    --pill-bg: var(--color-primary);
    --pill-color: var(--color-white);
    --pill-border-radius: var(--radius-md);
    --pill-padding: var(--spacing-sm) var(--spacing-md);
    --remove-color: var(--color-white);
  }

  .tag-selector-container {
    border: var(--tagger-border);
    border-radius: var(--tagger-border-radius);
    padding: var(--tagger-padding);
    position: relative;
    box-sizing: border-box;
  }

  .tag-selector-container[aria-disabled="true"] {
    opacity: 0.7;
    cursor: not-allowed;
  }

  .input-row {
    display: flex;
    gap: var(--spacing-md);
    align-items: center;
  }

  .tag-input {
    flex-grow: 1;
    padding: var(--input-padding);
    border: var(--input-border);
    outline: none;
    font-size: 1em;
    pointer-events: auto;
  }

  .quick-add-button {
    background-color: var(--surface-raised);
    border: 1px solid var(--color-primary);
    color: var(--color-primary);
    border-radius: var(--radius-md);
    padding: var(--spacing-sm) var(--spacing-lg);
    cursor: pointer;
  }

  .suggestions {
    border-radius: var(--radius-md);
    max-height: var(--suggestion-max-height);
    overflow-y: auto;
    margin-top: var(--spacing-lg);
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    gap: var(--spacing-sm);
    overscroll-behavior: contain;
  }

  .suggestion {
    padding: var(--spacing-sm);
    cursor: pointer;
    background-color: var(--color-primary);
    border-radius: var(--radius-lg);
    color: var(--color-white);
  }

  .suggestion:hover {
    background-color: var(--pill-bg);
  }

  .selected-tags {
    display: flex;
    gap: var(--spacing-md);
    flex-wrap: wrap;
  }

  .tag-pill {
    background-color: var(--pill-bg);
    color: var(--pill-color);
    border-radius: var(--pill-border-radius);
    padding: var(--pill-padding);
    display: flex;
    align-items: center;
    gap: var(--spacing-sm);
    cursor: pointer;
  }

  .tag-pill:hover {
    background-color: var(--color-primary);
  }

  .remove-tag {
    background: transparent;
    border: none;
    color: var(--remove-color);
    cursor: pointer;
  }

  .related-suggestions .suggestion {
    background-color: var(--color-secondary);
  }

  .suggestion.added {
    background-color: var(--color-gray-3);
    color: var(--on-surface);
    cursor: default;
  }

  .suggestion.added:hover {
    background-color: var(--color-gray-3);
  }

  .title-row {
    display: flex;
    align-items: center;
    gap: var(--spacing-sm);
    margin-bottom: var(--spacing-md);
  }

  p {
    margin: 0;
  }

  .publication-section {
    margin-bottom: var(--spacing-lg);
    background-color: var(--surface-sunken);
    padding: var(--spacing-md);
		border-radius: var(--radius-md);
		border: 1px dashed var(--color-app-dam);
		background-color: var(--surface-sunken);
		overflow: scroll;
		overscroll-behavior: contain;
		box-shadow: var(--shadow-300);
  }
  .no-selected-tags {
    display:flex;
    justify-content: center;
  }
  .related-suggestions {
    margin-bottom: var(--spacing-lg);
  }

  @media (max-width: 768px) {
    .tag-selector-container {
      max-width: 100%;
    }
    .suggestions {
      max-height: 150px;
    }
  }
`;
